import React from "react"


const Nav=({subCategorie, value,products, setValue,setFilterproduct, t}:any)=>{
   

    const tab=[{sub_category_name:"Tout"},...subCategorie]
    const setActiveNav=(label:any)=>{
        console.log("products",label)
        console.log("subCategorie",subCategorie)
        // console.log("my product", products)
        if (value !== label.sub_category_name ) {
            const filterProduct = products.filter((item:any)=>item.sub_category_id === label.sub_category_id)
            setFilterproduct(filterProduct)
            setValue(label.sub_category_name)
            if(label.sub_category_name === "Tout"){
                setFilterproduct(products.filter((item:any)=>item.category_id === subCategorie[0].category_id)) 
            }
        }
       
    }
    return(
        <div className=" w-full max-w-[400px] md:max-w-[99vw] flex  gap-2 px-2 md:px-4 items-center overflow-x-auto scrollbar-hide py-1">
          {
            tab.map((item:any, index:number)=>{
                const active = item.sub_category_name === value;
                return(
                    <span
                    onClick={()=>{setActiveNav(item)}}
                    className={`whitespace-nowrap cursor-pointer py-2 px-4 text-xs text-center rounded-xl transition-all duration-200 ${active
                      ? 'text-white bg-primary shadow-md shadow-primary/30'
                      : 'text-gray-600 hover:bg-gray-100 hover:text-primary ring-1 ring-gray-200'
                      }`}>
                         {t(`${item.sub_category_name}`)}
                    </span>
                )
            })
          }

        </div>
    )
}
export default Nav